import { Suspense } from 'react'
import { useRoutes } from 'react-router-dom'
import { protectedRoutes } from '@/routes/protected'
import { publicRoutes } from '@/routes/public'

export const AppRouter = () => {
  const routes = useRoutes([
    ...publicRoutes,
    ...protectedRoutes,
  ])

  return (
    <Suspense fallback={<></>}>
      {routes}
    </Suspense>
  )
}
